import React, { useState, useEffect } from 'react'

// css
import 'assets/style/components/product-list.scss'

// components
import IconButton from 'components/elements/IconButton'
import Image from 'components/elements/Image'
import Text from 'components/elements/Text'
import Tag from 'components/elements/Tag'
import HashTag from 'components/elements/HashTag'

//image
import { useMenuFrvtUpdate } from './../../api/common/search-fetch'

/*
content
  id = 'M30063'
  title = '오징어 야채 비빔밥'
  price = 1000
  tags = [{ text: 'FW그린테이아점', color: 'green' }]
  hashTags = ['할인', '달콤한 디저트', '여성추천', '학생추천']

starToggle = 별 버튼
onClick = 상품클릭
*/
function ProductListTilItem({
  isTil = false,
  image,
  cTTL = false, // CDN 이미지 캐싱
  isStore = true,
  content = {},
  onClick = () => {},
  toggleStar = () => {},
  isStar = false,
  flagStar = false,
  block = true,
  isSubTitle = false,
  isEllipsis = false,
  isMultiTitle = false,
  isHashTags = true,
  className = '',
  phbtUseUser = false,
  phbtUseSiteList = [],
  phbtUseUserShpt = '',
}) {
  
  const isPriceVisible = (siteId) => {
    return (
      !phbtUseSiteList?.includes(siteId) ||
      (phbtUseUser === true && 
        phbtUseSiteList?.includes(siteId) && 
        phbtUseUserShpt === siteId?.substring(0, 3))
    )
  }

  const menuFrvtUpdate = useMenuFrvtUpdate({
    successHandler: () => {},
    errorHandler: () => {},
  })

  const [star, setStar] = useState(content.star)
  const [watermarkYn, setWartermarkYn] = useState(false)
  const [imgUrl, setImgUrl] = useState('')

  useEffect(() => {
    setStar(flagStar)
  }, [flagStar])

  const clickStar = () => {
    toggleStar(star)
    setStar((prev) => !prev)
  }

  useEffect(() => {
    if (!image) return

    const [url, aiImageYn = ''] = image.split('@@@')

    if (aiImageYn === 'Y') setWartermarkYn(true)

    setImgUrl(url)
  }, [image])

  return (
    <>
      <li onClick={onClick}>
        {isTil ? (
          <>
            <div className={`img-wrap ${className}`}>
              <Image cTTL={cTTL} src={imgUrl} alt="타일형 이미지" watermarkYn={watermarkYn} />
              {isStar && (
                <IconButton
                  text="즐겨찾기"
                  size="32"
                  className={`star bookmark ${star ? 'active' : ''}`}
                  onClick={clickStar}
                />
              )}
            </div>
            <div className="tile-txt-group mt8">
              <span className="f-12 c-6">{content.id}</span>
              <p
                className={`mt4 f-14 c-3 f-bold ${isEllipsis ? 'text-ellipsis-1' : 'text-ellipsis-2'}`}
                style={isMultiTitle ? { minHeight: '42px' } : {}}
              >
                {content.title}
              </p>
              {(content.subTitle || isSubTitle) && (
                <span className={`block mt4 f-12 c-6 ${isEllipsis ? 'text-ellipsis-1' : ''}`}>
                  {content.subTitle}&nbsp;
                </span>
              )}
              {isHashTags && (
                <HashTag className="text-ellipsis-1" border="false" data={content.hashTags} block={block} />
              )}
              <Tag className="mt4 mb8" data={content.tags} />
              <div className="txt-price mt4">
                <Text className="price">
                  {isPriceVisible(content.siteId) ? (
                    <>
                      <b>{(content.price || 0).toLocaleString()}</b>
                      <span className="ml2">원{isStore ? '/점포가' : ''}</span>
                    </>
                  ) : (
                    <>
                      <b style={{ height: 30 }}></b>
                      <span className="ml2"></span>
                    </>
                  )}
                </Text>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="flex-between">
              <Tag className="mb0" data={content.tags} />
              {isStar && (
                <IconButton
                  text="즐겨찾기"
                  size="20"
                  className={`star bookmark-16 ${star ? 'active' : ''}`}
                  onClick={clickStar}
                />
              )}
            </div>
            <div className="flex mt8">
              <div className="img-wrap">
                <Image cTTL={cTTL} src={imgUrl} alt="타일형 이미지" watermarkYn={watermarkYn} />
              </div>
              <div className="tile-txt-group flex-1 ml12">
                <p className="f-bold">
                  {content.id && `[${content.id}]`} {content.title}
                </p>
                {(content.subTitle || isSubTitle) && (
                  <span className="block mt4 f-12 c-6">{content.subTitle}&nbsp;</span>
                )}
                {isHashTags && (
                  <HashTag className="text-ellipsis-1" border="false" data={content.hashTags} block={block} />
                )}
                <div className="txt-price mt4">
                  <Text className="price">
                    {isPriceVisible(content.siteId) ? (
                      <>
                        <b>{(content.price || 0).toLocaleString()}</b>
                        <span className="ml2">원{isStore ? '/점포가' : ''}</span>
                      </>
                    ) : (
                      <>
                        <b style={{ height: 30 }}></b>
                        <span className="ml2"></span>
                      </>
                    )}
                  </Text>
                </div>
              </div>
            </div>
          </>
        )}
      </li>
    </>
  )
}

export default ProductListTilItem
